<div class="logo-selector" #logoSelector [class.disabled]="disabled">
  <div
    mat-button
    class="d-flex align-items-center no-select logo-selector__button"
    [matMenuTriggerFor]="logosMenu"
    data-testId="logo-selector-button"
    (menuOpened)="onMenuOpened()"
    (menuClosed)="onMenuClosed()"
  >
    <div class="logo-selector__label">Select logo</div>
    <div class="flex-grow-1 one-line-text ml-2">
      <div class="logo-selector__value">
        <img [src]="selectedItem.path" alt="logo-img" />
        <span>{{ selectedItem.name }}</span>
      </div>
    </div>
    <mat-icon>expand_more</mat-icon>
  </div>
  <mat-menu #logosMenu="matMenu" yPosition="below" class="logo-seletor-options-container">
    <div class="px-3 pt-3 pb-2">
      <input
        class="form-control text-dark"
        [(ngModel)]="filterText"
        type="text"
        placeholder="Filter logos"
        (ngModelChange)="keyPressed()"
        (click)="$event.stopPropagation(); $event.preventDefault()"
        (focusout)="refocus($event)"
        data-testId="logo-selector-search-input"
      />
    </div>
    <div
      class="py-2 px-3 d-flex align-items-end no-select logos-list-container"
      *ngFor="let item of filteredLogos"
      (click)="menuItemClicked($event, item)"
      style="cursor: pointer"
      data-testId="logo-selector-option"
    >
      <div class="ml-2 d-flex logo-items">
        <div class="div-logo-img">
          <img class="logo-img" [src]="item.path" alt="logo-img" />
        </div>
        <div
          class="one-line-text"
          [title]="item.name"
        >
          {{ item.name }}
        </div>
        <mat-icon
          *ngIf="item.id == selectedItem.id"
          aria-hidden="false"
          aria-label="check icon"
          class="icon-logo-checked"
          fontIcon="check_small"
        ></mat-icon>
      </div>
    </div>
  </mat-menu>
</div>
